<template>
  <div class="container">
    <div class="img" :style="{ backgroundImage: 'url(' + info.imageUrl + ')' }">
      <!--<img :src="info.imageUrl" />-->
    </div>
    <div class="info">
      <div class="full-info">
        <h3>{{info.name}} {{info.lastName}}</h3>
        <h5>{{info.participantPosition.name}}</h5>
        <div class="vertical-info">
          <div>
            <h6>Date of birth</h6>
            <p>{{info.birthDate | moment("DD MMMM YYYY")}}</p>
          </div>
          <div>
            <h6>Club debute</h6>
            <p>{{info.joinedAt | moment("DD MMMM YYYY")}}</p>
          </div>
          <div>
            <h6>Country</h6>
            <p>
              <span class="country-overlay">
                <!--<flag :iso="info.country.code" />-->
              </span>
              <span class="country">{{info.country.name}}</span>
            </p>
          </div>
        </div>
        <div v-html="info.biography" class="staff-text"></div>
      </div>
      <div class="small-info">
        <div>
          <h6>Date of birth</h6>
          <p>{{info.birthDate | moment("DD MMMM YYYY")}}</p>
        </div>
        <div>
          <h6>Club debute</h6>
          <p>{{info.joinedAt | moment("DD MMMM YYYY")}}</p>
        </div>
        <div>
          <h6>Country</h6>
          <p>
            <span class="country-overlay">
              <!--<flag :iso="info.country.code" />-->
            </span>
            <span class="country">{{info.country.name}}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const url = process.env.VUE_APP_URL;
export default {
  name: "single-player",
  data() {
    return {
      id: this.$route.params.id,
      info: {
        img: "",
        participantPosition: {
          name: "",
        },
        country: {
          code: "",
          name: "",
        },
      },
    };
  },
  watch: {
    $route(to, from) {
      this.id = to.params.id;
    },
  },
  methods: {
    setPlayers() {
      this.axios
        .get(url + "/participants", {
          headers: {
            "Access-Control-Allow-Origin": "*",
            accept: "application/json",
          },
        })
        .then((response) => {
          const payload = response.data;
          this.$store.dispatch("setPlayers", payload);
          this.staff();
        });
    },
    staff() {
      const staffId = this.$route.params.id;
      this.$store.getters.staff.filter((el) => {
        if (el.id == staffId) {
          return (this.info = el);
        }
      });
    },
  },
  mounted() {
    this.setPlayers();
  },
};
</script>
<style lang="scss" scoped>
.my-flag {
  transform: scale(0.4) !important;
}
.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  padding-top: 10rem;
  padding-bottom: 10rem;
  @media only screen and (max-width: 1199px) {
    padding-top: 6rem;
  }
  .img {
    width: 35.5rem;
    padding-top: 45%;
    margin-right: 4.5rem;
    background-size: cover;
    background-position: top center;
    @media only screen and (max-width: 1199px) {
      width: 30rem;
      margin-right: 3rem;
    }
    @media only screen and (max-width: 992px) {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
    }
    @media only screen and (max-width: 768px) {
      width: 32%;
      max-width: 32%;
      margin-right: 1.5rem;
    }
    @media only screen and (max-width: 599px) {
      width: 100%;
      max-width: 35rem;
      padding-top: 37rem;
      margin: 0 auto 4rem;
    }
  }
  .info {
    padding-top: 6.5rem;
    width: calc(100% - 40rem);
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;

    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    //margin-bottom: 5rem;
    @media only screen and (max-width: 1199px) {
      width: calc(100% - 33rem);
      padding-top: 2rem;
    }
    @media only screen and (max-width: 992px) {
      padding-top: 0;
    }
    @media only screen and (max-width: 768px) {
      width: calc(68% - 1.5rem);
    }
    @media only screen and (max-width: 599px) {
      width: 100%;
    }
  }
}
.full-info {
  width: calc(82% - 13rem);
  @media only screen and (max-width: 1199px) {
    width: calc(78% - 3rem);
  }
  @media only screen and (max-width: 992px) {
    width: 100%;
  }
  h3 {
    font-size: 3rem;
    line-height: 4rem;
    font-weight: 700;
    margin-bottom: 1rem;
    @media only screen and (max-width: 992px) {
      font-size: 2.5rem;
      line-height: 3.5rem;
    }
  }
  h5 {
    font-size: 1.4rem;
    line-height: 1.4rem;
    text-transform: uppercase;
    font-weight: 400;
    color: #363636;
    margin-bottom: 4rem;
    @media only screen and (max-width: 1199px) {
      margin-bottom: 3rem;
    }
  }
  h4,
  p {
    font-size: 1.6rem;
    line-height: 3rem;
    font-weight: 500;
    @media only screen and (max-width: 992px) {
      font-size: 1.4rem;
      line-height: 2.2rem;
    }
  }
  h4 {
    margin-bottom: 1.5rem;
  }
  p {
    font-weight: 400;
    margin-bottom: 1rem;
  }
}

.small-info,
.vertical-info {
  width: 14rem;
  @media only screen and (max-width: 992px) {
    display: none;
  }
  & > div {
    margin-top: 3.5rem;
  }
  h6 {
    font-size: 1.2rem;
    font-weight: 300;
    margin-bottom: 0.7rem;
    text-transform: initial;
  }
  p {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    font-size: 1.6rem;
    font-weight: 700;
    margin-bottom: 0;
    span.country {
      display: inline-block;
      margin-left: 7px;
    }
  }
}
.vertical-info {
  display: none;
  @media only screen and (max-width: 992px) {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 2rem;
  }
  & > div {
    margin-top: 0;
    width: calc((100% - 3rem) / 3);
    margin-right: 1.5rem;
    margin-bottom: 0.5rem;
    &:last-of-type {
      margin-right: 0;
    }
    @media only screen and (max-width: 599px) {
      width: calc(50% - 1.5rem);
      margin-bottom: 1.5rem;
      &:nth-child(2) {
        margin-right: 0;
      }
    }
  }
}

.container.invisible {
  animation: slideDown 1s ease 1.5s forwards;
}

@keyframes slideDown {
  0% {
    opacity: 0;
    transform: translateY(30vw);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>